<template>
  <el-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="审批"
      width="500px"
      @close="handleClose">
    <div style="max-height: 300px; overflow-y: auto;">
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="审批意见" prop="result">
          <el-radio-group v-model="formData.result" @change="onResultChange">
            <el-radio label="approved">同意</el-radio>
            <el-radio label="rejected">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批理由" prop="reason">
          <el-input
              v-model="formData.reason"
              type="textarea"
              :rows="4"
              placeholder="请输入审批理由"
              maxlength="200"
              show-word-limit/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "ApprovalDialog",
    data() {
      const validateReason = (rule, value, callback) => {
        if (this.formData.result === "rejected" && (!value || !value.trim())) {
          callback(new Error("驳回时必须填写审批理由"));
        } else {
          callback();
        }
      };
      return {
        dialogVisible: false,
        submitLoading: false,
        selectedRows: [],
        formData: {
          result: "approved",
          reason: "",
        },
        rules: {
          result: {required: true, message: "请选择审批意见", trigger: "change"},
          reason: {validator: validateReason, trigger: "blur"},
        },
      };
    },
    methods: {
      open(selection) {
        if (!selection || !selection.length) {
          this.$message.warning("请先勾选需要审批的记录");
          return;
        }
        this.selectedRows = selection;
        this.formData = {result: "approved", reason: ""};
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
      },
      onResultChange() {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validateField("reason");
        });
      },
      handleClose() {
        this.$refs.form && this.$refs.form.resetFields();
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            const ids = this.selectedRows.map((row) => row.pkId);
            this.$http
              .post("basic", "salesForecasts/batchApprove", {
                ids,
                result: this.formData.result === "approved",
                reason: this.formData.reason,
              })
              .then((resp) => {
                if (resp.success) {
                  this.$message.success("审批成功");
                  this.$emit("save-success");
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
